export enum CodeType {
    BATCH = 'BATCH',
}
